import { DesBaseCollabAcc } from './des-base-collab-acc';
export class DesBaseRfqIdRfqQuoteId extends DesBaseCollabAcc {

    constructor(ViewModel) {
        super(ViewModel);
        this.ViewModel = ViewModel;
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            rfqid: this.rfqid,
            rfqquoteid: this.rfqquoteid
        };
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get rfqid() {
        return this.getAttribute('rfqid') || this.getAttribute('rfq-id');
    }

    get rfqquoteid() {
        return this.getAttribute('rfqquoteid') || this.getAttribute('rfq-quote-id');
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id', 'rfqid', 'rfq-id', 'rfqquoteid', 'rfq-quote-id' ];
    }
}
